<template>
  <div id="processinfo" v-loading="loading">
    <process
      :taskType="taskType"
      :taskId="taskId"
      :key="taskId"
      @setType="setType"
      @closeLoading="loading = false"
      @refush="refush"
      @close="close"
      @addTab="addTab"
    />
  </div>
</template>

<script>
import process from "@/components/process/index.vue";
export default {
  name: "processinfo",
  props: {
    taskId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      taskType: "watch",
      loading: false
    };
  },
  mounted() {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
  methods: {
    setType(v) {
      this.taskType = v;
    },
    refush() {
      this.$emit("refush");
    },
    addTab(data) {
      this.$emit("addTab", data);
    },
    close() {
      this.$emit("close");
    }
  },
  components: {
    process
  }
};
</script>

<style lang="scss" scoped>
#processinfo {
  height: calc(100% + var(--padding) * 2);
  width: calc(100% + var(--padding) * 2);
  margin: var(--paddingf);
  position: relative;
  overflow: hidden;
}
</style>
